/**
 * The query parameter name for the search terms.
 *
 * @const {string}
 */
export const SEARCH_QUERY_PARAM = 's';
